import React, { FC } from 'react';
import { PageSection, Tab } from 'components';
import { useTranslation } from 'react-i18next';
import { Container, Title, SecondaryBlocksContainer } from './styled';
import { MainBlock } from './MainBlock';
import { SecondaryBlock } from './SecondaryBlock';
import { CSSObject } from 'styled-components';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 60,
            paddingBottom: 103,

            '@media(max-width: 1279px)': {
                paddingTop: 110,
            },

            '@media(max-width: 1023px)': {
                paddingTop: 60,
                paddingBottom: 27,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
        },
    },
};

interface ConstructorProps {
    bgImagePath: string;
    title: string;
    bgStyles?: CSSObject;
}

export const Constructor: FC<ConstructorProps> = ({
    bgImagePath,
    title,
    bgStyles,
}) => {
    const { t } = useTranslation('pages/for-businesses');

    const tabs = {
        tabs: [
            {
                key: 'tech',
                isActive: true,
                body: (
                    <>
                        <MainBlock
                            config={{
                                title: t('constructor-title-1'),
                                subtitle: t('constructor-subtitle-1'),
                                imagePath:
                                    '/assets/images/bussiness/laptop.png',
                                link: '/courses/1/n/2,10,11,12,13,14/n/2',
                                imageStyles: {
                                    backgroundPositionX: '151%',
                                    backgroundPositionY: '19%',
                                    backgroundSize: '75%',
                                    '@media(max-width: 1023px)': {
                                        backgroundPosition: '50%',
                                    },
                                },
                            }}
                        />
                        <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-10'),
                                    subtitle: t('constructor-subtitle-10'),
                                    link: '/courses/1/n/14/n/2',
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-11'),
                                    subtitle: t('constructor-subtitle-11'),
                                    link: '/courses/n/n/15/n/2',
                                }}
                            />
                        </SecondaryBlocksContainer>
                    </>
                ),
                title: <span>{t('constructor-tech')}</span>,
            },
            {
                key: 'cyber',
                body: (
                    <>
                        <MainBlock
                            config={{
                                title: t('constructor-title-12'),
                                subtitle: t('constructor-subtitle-12'),
                                imagePath: '/assets/images/bussiness/cyber.jpg',
                                link: '/courses/n/n/7/n/2',
                                imageStyles: {
                                    backgroundPositionX: '120px',
                                    backgroundPositionY: '22%',
                                    '@media(max-width: 1023px)': {
                                        backgroundPositionX: 'right',
                                    },
                                },
                            }}
                        />
                        <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-13'),
                                    subtitle: t('constructor-subtitle-13'),
                                    link: '/courses/n/n/5/n/2',
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-14'),
                                    subtitle: t('constructor-subtitle-14'),
                                    link: '/courses/2/n/14/n/2',
                                }}
                            />
                        </SecondaryBlocksContainer>
                    </>
                ),
                title: <span>{t('constructor-cyber')}</span>,
            },
        ],
        styles: {
            textColor: '#fff',
            rootStyles: `
                    border-radius: 10px 10px 0px 0px;
            `,
            menuStyles:
                'padding: 0; gap: 40px; padding: 0 70px; justify-content: center;' +
                '@media only screen and (max-width: 1023px) { flex-direction: row !important; border-bottom: none !important; gap: 10px !important; padding: 0; flex-wrap: wrap; justify-content: flex-start; }',
            menuItemStyles:
                'padding: 20px 0; font-size: 21px; line-height: 24px; font-weight: 300; &:after { background: #3DE8CA; bottom: -2px; }' +
                '@media only screen and (max-width: 1023px) { &:after { display: none; }; font-size: 16px; line-height: 14px; padding: 5px 12px; background: #ECEFF3; color: #000000; white-space: nowrap; ' +
                'border-radius: 24px; width: auto !important; &.is-active { padding-right: 26px; background: linear-gradient(45deg, #3DE8CA 38.74%, #33FF77 100%); &:before { content: "✖"; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 12px; }; } }',
            bodyStyles: 'padding: 40px 0 0 0;',
        },
    };

    return (
        <Container bgImagePath={bgImagePath} bgStyles={bgStyles}>
            <PageSection config={sectionConfig}>
                <Title>{title}</Title>
                <Tab {...tabs} />
            </PageSection>
        </Container>
    );
};
